export default __webpack_public_path__ + "static/media/english-to-turkish-screenshot-06.729301ea.png";